import $ from 'jquery';

export default class BackgroundAnimate {
    constructor() {
        if ($('.o-flexible-module').length) {
            $(window).on( 'scroll', function () {
                const $window = $(window);
                const $body = $('body');
                const $panel = $('.o-flexible-module');

                let scroll = $window.scrollTop() + ($window.height() / 3);

                $panel.each(function () {
                    const $this = $(this);

                    if ($this.position().top <= scroll && $this.position().top + $this.height() > scroll) {
                        if (!$body.hasClass('bg-colour-' + $(this).data('colour'))) {
                            $body.removeClass(function (index, css) {
                                return (css.match(/(^|\s)bg-colour-\S+/g) || []).join(' ');
                            });

                            $body.addClass('bg-colour-' + $(this).data('colour'));
                        };
                    };
                });

            }).scroll();
        };
    };
};
